import MyBottomNav from 'lib/components/Nav/BottomNav';
import { ThemeUIProvider } from 'theme-ui';
import { theme, widths } from './theme';

export default function BottomNavApp() {
  return (
    <ThemeUIProvider theme={theme}>
      <MyBottomNav
        width={widths}
        sx={{
          paddingX: 3,
          height: 52,
          textShadow: 'none',
          width: '100vw',
          marginLeft: 'calc(-50vw + 50%)'
        }}
      />
    </ThemeUIProvider>
  );
}
